import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_counter_input_desktop = _resolveComponent("counter-input-desktop")!
  const _component_counter_input_mobile = _resolveComponent("counter-input-mobile")!

  return (!_ctx.isMobile)
    ? (_openBlock(), _createBlock(_component_counter_input_desktop, _mergeProps({
        key: 0,
        class: "counter--d"
      }, _ctx.$props, {
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update', $event))),
        onAddToBasket: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('addToBasket', $event))),
        ref: "counterInputDesktop"
      }), null, 16 /* FULL_PROPS */))
    : (_openBlock(), _createBlock(_component_counter_input_mobile, _mergeProps({
        key: 1,
        class: "counter--m"
      }, _ctx.$props, {
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update', $event))),
        onAddToBasket: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('addToBasket', $event))),
        ref: "counterInputMobile"
      }), null, 16 /* FULL_PROPS */))
}